<template>
  <LoginLayout :image="getImageUrl()" :is-page="true" :is-reset-password="true">
    <div class="mx-auto max-w-md px-6 lg:my-24 lg:px-0">
      <ForgotPasswordForm :module="module" :show-default-title="true" />
    </div>
  </LoginLayout>
</template>

<script setup lang="ts">
/** components */
import ForgotPasswordForm from '~/components/ForgotPasswordForm.vue'
import LoginLayout from '~/components/common/LoginLayout.vue'

/** composables */
import { useSeo } from '~/composables/useSeo'
import { useScreenSize } from '~/composables/useScreenSize'

/** constants */
import { MANAGE_PASSWORD_IMAGES } from '~/src/constants/auth'
import { TYPES_MODULE } from '~/src/constants/forms'
import { IMAGE_SIZES } from '~/src/constants/common'

/** app */
const { getSeoInfo } = useSeo()
const seo = getSeoInfo({ title: 'Reset your password' })
const { isNotDesktop } = useScreenSize()

/** refs */
const module = ref<TYPES_MODULE>(TYPES_MODULE.PAGE)

/** computed */
const imageType = computed(() => {
  return isNotDesktop.value ? IMAGE_SIZES.MOBILE : IMAGE_SIZES.DESKTOP
})

/** methods */
const getImageUrl = () => MANAGE_PASSWORD_IMAGES[imageType.value]

useHead(seo)
definePageMeta({ layout: 'empty' })
</script>
